<template>
    <nav class="nav-list" v-for="(navigationItem, index) in cNavigation" :key="`desktop-${index}`">
        <template
            v-for="(link, index) in navigationItem.NavigationLinks"
            :key="`desktop-${link.Text}-${index}`">
            <sub-nav v-if="link.SubItems.length > 0" :item="link"></sub-nav>
            <a
                v-else
                :href="link.MainLink.Url"
                :target="link.MainLink.Target"
                :class="{ 'is-active': link.MainLink.Active }"
                class="link"
                >{{ link.MainLink.Text }}</a
            >
        </template>
        <a
            :href="secondaryNav.Url"
            :target="secondaryNav.Target"
            :class="{ 'is-active': secondaryNav.Active }"
            class="link link--thin"
            >{{ secondaryNav.Text }}</a
        >
    </nav>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { INavigation, ILink } from '../../../interfaces/Navigation';
import { useDesktopNavStore } from '../store/desktop-nav.store';
import subNav from './subNav.component.vue';

const props = defineProps<{
    navigation: INavigation[];
    secondaryNav: ILink;
}>();

const desktopNavStore = useDesktopNavStore();

console.log('desktop navigation', props.navigation);

const cNavigation = computed(() => {
    return props.navigation.filter((x) => x.Type === desktopNavStore.navigationType);
});
</script>
